// src/pages/Vistoria/vistoria.jsx
import React, {
    useEffect,
    useState,
    useCallback,
    useRef,
    memo
} from 'react';

import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';

import {
    ReactSketchCanvas
} from 'react-sketch-canvas';

import imageCompression from 'browser-image-compression';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import {
    FaPlus,
    FaClipboardCheck,
    FaArrowLeft,
    FaFilePdf,
    FaWhatsapp,
    FaImage,
    FaSave,
    FaUndo,
    FaCamera,
    FaCheck,
    FaExclamationTriangle,
    FaStore,
    FaUser,
    FaCalendarAlt,
    FaPencilAlt,
    FaSearchPlus
} from 'react-icons/fa';

import './vistoria.css';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const FotoItemPreview = memo(({
    foto,
    loading,
    onAmpliar
}) => {

    if (loading) {
        return (
            <div
                className="border rounded-3 bg-light d-flex flex-column align-items-center justify-content-center w-100"
                style={{ height: '180px', boxSizing: 'border-box' }}
            >
                <div className="spinner-border spinner-border-sm text-custom-red mb-2"></div>
                <small className="text-muted fw-semibold x-small">A carregar...</small>
            </div>
        );
    }

    if (!foto) {
        return (
            <div
                className="border rounded-3 bg-light d-flex flex-column align-items-center justify-content-center text-muted x-small fw-semibold w-100"
                style={{ height: '180px', boxSizing: 'border-box' }}
            >
                <FaImage className="d-block mb-1 opacity-50 fs-4" />
                <span>SEM FOTO</span>
            </div>
        );
    }

    return (
        <div 
            className="position-relative cursor-pointer w-100 overflow-hidden rounded-3 border shadow-xs vistoria-foto-container" 
            onClick={() => onAmpliar(`data:image/jpeg;base64,${foto}`)}
        >
            <img
                src={`data:image/jpeg;base64,${foto}`}
                alt="Foto Vistoria"
                loading="lazy"
                className="vistoria-img-fill"
            />
            <div className="vistoria-zoom-badge">
                <FaSearchPlus />
            </div>
        </div>
    );
});

FotoItemPreview.displayName = 'FotoItemPreview';

const VistoriaGestao = () => {

    const [loading, setLoading] = useState(false);
    const [loadingTexto, setLoadingTexto] = useState("Processando...");

    const [etapa, setEtapa] = useState('LISTA');
    const [vistorias, setVistorias] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [lojaSelecionada, setLojaSelecionada] = useState("0");
    const [filtroVisao, setFiltroVisao] = useState("TODAS");

    const [vistoriaAtual, setVistoriaAtual] = useState(null);
    const [prazoFinalizacao, setPrazoFinalizacao] = useState('');

    const [ponto, setPonto] = useState({
        descricao: '',
        tipo: 'TAREFA',
        foto: ''
    });

    const [itensNovaVistoria, setItensNovaVistoria] = useState([]);
    const [vistoriaEmAnalise, setVistoriaEmAnalise] = useState(null);
    const [obsSupervisorGeral, setObsSupervisorGeral] = useState('');
    const [itensAnalise, setItensAnalise] = useState([]);
    const [previewEdicao, setPreviewEdicao] = useState(null);
    const [imagemTempBase64, setImagemTempBase64] = useState(null);
    const [fotoAmpliada, setFotoAmpliada] = useState(null);

    const canvasRef = useRef(null);
    const fotosCacheRef = useRef({});

    const idLojaPadrao = localStorage.getItem("loja");
    const chapaUsuario = localStorage.getItem("chapa");

    // Perfis
    const eDiretorOuRegional =
        localStorage.getItem("permiteRegional") === 'S' ||
        localStorage.getItem("diretor") === 'S';

    const temVistoriaLoja = localStorage.getItem("vistoriaLoja") === 'S';

    // Pode criar vistorias
    const podeCriar = eDiretorOuRegional || temVistoriaLoja;

    const carregarVistorias = useCallback(async (codEmp, visaoParam) => {
        try {
            const res = await api.get('/vistoria');
            let lista = res.data || [];
            const visaoAtual = visaoParam !== undefined ? visaoParam : filtroVisao;

            const chapaLimpa = String(chapaUsuario || '').trim();

            if (temVistoriaLoja && !eDiretorOuRegional) {
                lista = lista.filter(x => {
                    const idCriador = String(
                        x.chapa || x.CHAPA ||
                        x.id_supervisor || x.ID_SUPERVISOR ||
                        x.matricula || x.MATRICULA ||
                        x.id_usuario || x.ID_USUARIO ||
                        x.cod_usuario || ''
                    ).trim();

                    return idCriador === chapaLimpa || Number(idCriador) === Number(chapaLimpa);
                });
            }

            if (codEmp !== "0" && codEmp !== 0) {
                lista = lista.filter(
                    x => String(x.id_loja || x.ID_LOJA) === String(codEmp)
                );
            }

            if (eDiretorOuRegional && visaoAtual === "MINHAS") {
                lista = lista.filter(x => {
                    const idCriador = String(
                        x.chapa || x.CHAPA ||
                        x.id_supervisor || x.ID_SUPERVISOR ||
                        x.matricula || x.MATRICULA ||
                        x.id_usuario || x.ID_USUARIO ||
                        x.cod_usuario || ''
                    ).trim();

                    return idCriador === chapaLimpa || (chapaLimpa !== '' && Number(idCriador) === Number(chapaLimpa));
                });
            }

            setVistorias(lista);

        } catch (err) {
            console.error(err);
        }
    }, [temVistoriaLoja, eDiretorOuRegional, chapaUsuario, filtroVisao]);

    const salvarObsSupervisor = async () => {
        if (!vistoriaEmAnalise) return;
        try {
            setLoadingTexto("Gravando observações do supervisor...");
            setLoading(true);

            await api.put(`/vistoria/${vistoriaEmAnalise.id_vistoria}/obs-supervisor`, {
                obs_supervisor: obsSupervisorGeral
            });

            setVistoriaEmAnalise(prev => ({
                ...prev,
                obs_geral: obsSupervisorGeral,
                OBS_GERAL: obsSupervisorGeral,
                obs_supervisor: obsSupervisorGeral,
                OBS_SUPERVISOR: obsSupervisorGeral
            }));

            setVistorias(prev => prev.map(item => {
                if (String(item.id_vistoria) === String(vistoriaEmAnalise.id_vistoria)) {
                    return {
                        ...item,
                        obs_geral: obsSupervisorGeral,
                        OBS_GERAL: obsSupervisorGeral,
                        obs_supervisor: obsSupervisorGeral,
                        OBS_SUPERVISOR: obsSupervisorGeral
                    };
                }
                return item;
            }));

            Swal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: 'Observações salvas com sucesso!',
                confirmButtonColor: '#991b1b'
            });
        } catch (err) {
            console.error(err);
            Swal.fire('Erro', 'Falha ao salvar observações.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const gerarPdfEEmail = () => {
        const carregando = itensAnalise.some(item => item.loadingFoto);
        if (carregando) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Aguarde o carregamento de todas as fotos antes de gerar o relatório.',
                confirmButtonColor: '#991b1b'
            });
        }

        try {
            setLoadingTexto("Montando relatório PDF...");
            setLoading(true);

            const conteudo = [
                {
                    text: `Relatório de Vistoria às Lojas - #${vistoriaEmAnalise.id_vistoria}`,
                    fontSize: 16,
                    bold: true,
                    margin: [0, 0, 0, 10]
                },
                {
                    text: `Loja: ${vistoriaEmAnalise.razao || ''} (${vistoriaEmAnalise.id_loja})`,
                    fontSize: 12,
                    margin: [0, 0, 0, 5]
                },
                {
                    text: `Solicitante: ${vistoriaEmAnalise.nome || 'Não informado'}`,
                    margin: [0, 0, 0, 15]
                }
            ];

            if (obsSupervisorGeral && String(obsSupervisorGeral).trim() !== '') {
                conteudo.push({
                    table: {
                        widths: ['*'],
                        body: [[
                            {
                                stack: [
                                    { text: '📌 OBSERVAÇÕES E ROTINAS ADICIONAIS DO SUPERVISOR', bold: true, color: '#991b1b', fontSize: 11, margin: [0, 0, 0, 5] },
                                    { text: String(obsSupervisorGeral), color: '#1e293b', fontSize: 10 }
                                ],
                                fillColor: '#fef2f2',
                                margin: [8, 8, 8, 8]
                            }
                        ]]
                    },
                    layout: {
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => '#fecaca',
                        vLineColor: () => '#fecaca'
                    },
                    margin: [0, 0, 0, 15]
                });
            }

            itensAnalise.forEach((item, index) => {
                conteudo.push({
                    text: `Item ${index + 1}: ${item.tipo}`,
                    bold: true,
                    fontSize: 12,
                    margin: [0, 15, 0, 5]
                });
                const descOriginal = item.descricao_ponto || item.descricao || '';

                if (descOriginal.includes('[RÉPLICA]:')) {
                    const partes = descOriginal.split('[RÉPLICA]:');
                    const textoPrincipal = partes[0].replace(/<\/?b>/gi, '').trim();
                    const textoReplica = partes[1].replace(/<\/?b>/gi, '').trim();

                    conteudo.push({
                        text: `Solicitado: ${textoPrincipal}`,
                        margin: [0, 0, 0, 5]
                    });

                    conteudo.push({
                        table: {
                            widths: ['*'],
                            body: [[
                                {
                                    text: `[RÉPLICA]: ${textoReplica}`,
                                    color: '#842029',
                                    bold: true,
                                    fontSize: 10,
                                    fillColor: '#f8d7da',
                                    margin: [5, 5, 5, 5]
                                }
                            ]]
                        },
                        layout: {
                            hLineWidth: () => 1,
                            vLineWidth: () => 1,
                            hLineColor: () => '#f5c2c7',
                            vLineColor: () => '#f5c2c7'
                        },
                        margin: [0, 2, 0, 8]
                    });
                } else {
                    conteudo.push({
                        text: `Solicitado: ${descOriginal.replace(/<\/?b>/gi, '')}`,
                        margin: [0, 0, 0, 5]
                    });
                }
                conteudo.push({
                    text: `Usuário: ${item.nome || ''}`,
                    bold: true,
                    fontSize: 12,
                    margin: [0, 15, 0, 5]
                });
                conteudo.push({
                    text: `Solução/Realizado: ${item.obs_gerente || 'Pendente'}`,
                    margin: [0, 0, 0, 15]
                });

                const colunasImagens = {
                    columns: [],
                    columnGap: 15,
                    margin: [0, 0, 0, 20],
                    unbreakable: true
                };

                const getBase64 = (foto) => foto.startsWith('data:image') ? foto : `data:image/jpeg;base64,${foto}`;

                if (item.foto_antes) {
                    colunasImagens.columns.push({
                        stack: [
                            { text: 'Antes', alignment: 'center', fontSize: 10, margin: [0, 0, 0, 5], bold: true },
                            { image: getBase64(item.foto_antes), width: 240, alignment: 'center' }
                        ],
                        width: 240
                    });
                } else {
                    colunasImagens.columns.push({
                        stack: [
                            { text: 'Antes', alignment: 'center', fontSize: 10, margin: [0, 0, 0, 5], bold: true },
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [150],
                                    body: [
                                        [{ text: 'Sem foto', alignment: 'center', margin: [0, 65, 0, 0], color: '#6c757d', fillColor: '#f8f9fa' }]
                                    ]
                                },
                                layout: { hLineColor: () => '#dee2e6', vLineColor: () => '#dee2e6' }
                            }
                        ],
                        width: 240
                    });
                }

                if (item.foto_depois) {
                    colunasImagens.columns.push({
                        stack: [
                            { text: 'Depois', alignment: 'center', fontSize: 10, margin: [0, 0, 0, 5], bold: true },
                            { image: getBase64(item.foto_depois), width: 240, alignment: 'center' }
                        ],
                        width: 240
                    });
                } else {
                    colunasImagens.columns.push({
                        stack: [
                            { text: 'Depois', alignment: 'center', fontSize: 10, margin: [0, 0, 0, 5], bold: true },
                            {
                                table: {
                                    widths: ['*'],
                                    heights: [150],
                                    body: [
                                        [{ text: 'Sem foto', alignment: 'center', margin: [0, 65, 0, 0], color: '#6c757d', fillColor: '#f8f9fa' }]
                                    ]
                                },
                                layout: { hLineColor: () => '#dee2e6', vLineColor: () => '#dee2e6' }
                            }
                        ],
                        width: 240
                    });
                }

                conteudo.push(colunasImagens);
                conteudo.push({ canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#e9ecef' }] });
            });

            const docDefinition = {
                pageSize: 'A4',
                pageMargins: [40, 40, 40, 40],
                content: conteudo,
                footer: function (currentPage, pageCount) {
                    return {
                        text: `${currentPage} / ${pageCount}`,
                        alignment: 'right',
                        fontSize: 9,
                        margin: [0, 10, 40, 0],
                    };
                },
            };

            const nomeArquivo = `Vistoria_${vistoriaEmAnalise.id_vistoria}_Loja_${vistoriaEmAnalise.id_loja}.pdf`;

            pdfMake.createPdf(docDefinition).download(nomeArquivo, () => {
                const assunto = encodeURIComponent(`Relatório de Vistoria #${vistoriaEmAnalise.id_vistoria} - Loja ${vistoriaEmAnalise.id_loja}`);
                const corpo = encodeURIComponent(`Olá,\n\nSegue o detalhamento da vistoria realizada.\n\nPor favor, insira em anexo o arquivo PDF (${nomeArquivo}) que acabou de ser baixado no seu computador.\n\nAtenciosamente,\nEquipe de TI`);

                window.location.href = `mailto:?subject=${assunto}&body=${corpo}`;
                setLoading(false);
            });

        } catch (error) {
            console.error('Erro ao gerar PDF:', error);
            Swal.fire('Erro', 'Falha ao processar o relatório em PDF.', 'error');
            setLoading(false);
        }
    };

    useEffect(() => {
        api.get("lojas/localizacao")
            .then(res => {
                setLojas(res.data || []);

                if (eDiretorOuRegional) {
                    setLojaSelecionada("0");
                    carregarVistorias("0", filtroVisao);
                } else {
                    setLojaSelecionada(idLojaPadrao || "0");
                    carregarVistorias(idLojaPadrao || "0", filtroVisao);
                }
            });
    }, [idLojaPadrao, eDiretorOuRegional, carregarVistorias, filtroVisao]);

    const solicitarReplicaSupervisor = async (item) => {
        const { value: obsSupervisor } = await Swal.fire({
            title: 'Solicitar Réplica',
            input: 'textarea',
            inputLabel: 'Informe o motivo da contestação para o Gerente:',
            inputPlaceholder: 'Ex: Foto enviada não corresponde à solução do item. Por favor, enviar nova evidência.',
            showCancelButton: true,
            confirmButtonText: 'Exigir Réplica',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#991b1b',
            cancelButtonColor: '#64748b',
            customClass: { popup: 'rounded-4' },
            inputValidator: (value) => {
                if (!value) {
                    return 'Você precisa descrever a justificativa para a réplica!';
                }
            }
        });

        if (obsSupervisor) {
            try {
                setLoadingTexto("Enviando solicitação de réplica...");
                setLoading(true);

                await api.put('/vistoria/replicar', {
                    id_item: item.id_item,
                    obs_supervisor: obsSupervisor
                });

                if (fotosCacheRef.current[item.id_item]) {
                    fotosCacheRef.current[item.id_item].foto_depois = null;
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso',
                    text: 'O item foi alterado para REPLICA e o gerente deverá reenviar a foto.',
                    confirmButtonColor: '#991b1b'
                });

                await abrirAnalise(vistoriaEmAnalise);

            } catch (e) {
                console.error(e);
                Swal.fire('Erro', 'Falha ao registrar réplica.', 'error');
            } finally {
                setLoading(false);
            }
        }
    };

    const criarOuContinuarVistoria = async () => {
        if (lojaSelecionada === "0" || !lojaSelecionada) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Selecione uma loja.',
                confirmButtonColor: '#991b1b'
            });
        }

        try {
            setLoadingTexto("Iniciando auditoria...");
            setLoading(true);

            const existente = vistorias.find(
                x =>
                    (x.status === 'CRIANDO' || x.STATUS === 'CRIANDO') &&
                    String(x.id_loja || x.ID_LOJA) === String(lojaSelecionada)
            );

            if (existente) {
                await continuarInclusao(existente);
                return;
            }

            const res = await api.post('/vistoria', {
                id_loja: lojaSelecionada,
                id_supervisor: localStorage.getItem("chapa")
            });

            setVistoriaAtual({
                id_vistoria: res.data.id_vistoria,
                id_loja: lojaSelecionada,
                status: 'CRIANDO'
            });

            setItensNovaVistoria([]);
            setEtapa('NOVO');

            await carregarVistorias(lojaSelecionada, filtroVisao);

        } catch (e) {
            console.error(e);
            Swal.fire('Erro', 'Falha ao iniciar vistoria.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const continuarInclusao = async (vistoria) => {
        try {
            setLoadingTexto("Carregando itens pendentes...");
            setLoading(true);

            const res = await api.get(`/vistoria/${vistoria.id_vistoria}/itens`);

            setItensNovaVistoria(res.data || []);
            setVistoriaAtual(vistoria);
            setEtapa('NOVO');

        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const abrirAnalise = async (v) => {
        try {
            setLoadingTexto("Buscando pontos da vistoria...");
            setLoading(true);

            const resItens = await api.get(`/vistoria/${v.id_vistoria}/itens`);

            const itens = (resItens.data || []).map(item => ({
                ...item,
                foto_antes: fotosCacheRef.current[item.id_item]?.foto_antes || null,
                foto_depois: fotosCacheRef.current[item.id_item]?.foto_depois || null,
                loadingFoto: !fotosCacheRef.current[item.id_item]
            }));

            setItensAnalise(itens);
            setVistoriaEmAnalise(v);

            try {
                const resRelatorio = await api.get(`/vistoria/${v.id_vistoria}/relatorio`);
                const cabecalho = resRelatorio.data?.cabecalho || {};

                const obsDoBanco = cabecalho.obs_geral || cabecalho.OBS_GERAL || cabecalho.obs_supervisor || cabecalho.OBS_SUPERVISOR || v.obs_geral || v.OBS_GERAL || '';
                setObsSupervisorGeral(String(obsDoBanco));
            } catch (e) {
                console.error("Erro ao buscar cabecalho atualizado:", e);
                const obsFallback = v.obs_geral || v.OBS_GERAL || v.obs_supervisor || v.OBS_SUPERVISOR || '';
                setObsSupervisorGeral(String(obsFallback));
            }

            setEtapa('ANALISE');
            setLoading(false);

            itens.forEach(async (item) => {
                if (fotosCacheRef.current[item.id_item]) return;

                try {
                    const resFoto = await api.get(`/vistoria/foto/${item.id_item}`);
                    const foto = resFoto.data?.[0] || {};

                    const dadosFoto = {
                        foto_antes: foto.foto_antes || null,
                        foto_depois: foto.foto_depois || null
                    };

                    fotosCacheRef.current[item.id_item] = dadosFoto;

                    setItensAnalise(prev =>
                        prev.map(x => (x.id_item === item.id_item ? { ...x, ...dadosFoto, loadingFoto: false } : x))
                    );

                } catch (e) {
                    console.error(e);
                    setItensAnalise(prev =>
                        prev.map(x => (x.id_item === item.id_item ? { ...x, loadingFoto: false } : x))
                    );
                }
            });

        } catch (err) {
            console.error(err);
            setLoading(false);
            Swal.fire('Erro', 'Não foi possível carregar os detalhes.', 'error');
        }
    };

    const handleFotoPonto = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setLoadingTexto("Otimizando tamanho do arquivo...");
            setLoading(true);

            const compressedFile = await imageCompression(file, {
                maxSizeMB: 0.4,
                maxWidthOrHeight: 1600,
                useWebWorker: true
            });

            const reader = new FileReader();

            reader.onload = () => {
                setImagemTempBase64(reader.result);
                setPreviewEdicao(reader.result);
            };

            reader.readAsDataURL(compressedFile);

        } catch (err) {
            console.error(err);
            Swal.fire('Erro', 'Falha ao processar imagem.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const salvarEdicaoFoto = async () => {
        try {
            setLoadingTexto("Renderizando canvas gráfico...");
            setLoading(true);

            const paths = await canvasRef.current.exportPaths();

            if (!paths || paths.length === 0) {
                setPonto(prev => ({
                    ...prev,
                    foto: imagemTempBase64.split(',')[1]
                }));
                setPreviewEdicao(null);
                setLoading(false);
                return;
            }

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();

            img.src = imagemTempBase64;

            img.onload = async () => {
                canvas.width = img.width;
                canvas.height = img.height;

                ctx.drawImage(img, 0, 0);

                paths.forEach(path => {
                    ctx.beginPath();
                    ctx.strokeStyle = path.strokeColor || 'red';
                    ctx.lineWidth = path.strokeWidth || 5;

                    path.paths.forEach((p, index) => {
                        if (index === 0) {
                            ctx.moveTo(p.x, p.y);
                        } else {
                            ctx.lineTo(p.x, p.y);
                        }
                    });

                    ctx.stroke();
                });

                const finalBase64 = canvas.toDataURL('image/jpeg', 0.8);

                setPonto(prev => ({
                    ...prev,
                    foto: finalBase64.split(',')[1]
                }));

                setPreviewEdicao(null);
                setLoading(false);
            };

        } catch (e) {
            console.error(e);
            setLoading(false);
            Swal.fire('Erro', 'Falha ao salvar edição.', 'error');
        }
    };

    const adicionarItem = async () => {
        if (!ponto.descricao) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Informe a descrição.',
                confirmButtonColor: '#991b1b'
            });
        }

        if (ponto.tipo === 'TAREFA' && !ponto.foto) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'GERAR TAREFA exige foto.',
                confirmButtonColor: '#991b1b'
            });
        }

        try {
            setLoadingTexto("Salvando apontamento no banco...");
            setLoading(true);

            await api.post('/vistoria/item', {
                id_vistoria: vistoriaAtual.id_vistoria,
                descricao: ponto.descricao,
                tipo: ponto.tipo,
                foto: ponto.foto
            });

            const res = await api.get(`/vistoria/${vistoriaAtual.id_vistoria}/itens`);

            setItensNovaVistoria(res.data || []);
            setPonto({
                descricao: '',
                tipo: 'TAREFA',
                foto: ''
            });

            const elInput = document.getElementById('foto-input');
            if (elInput) elInput.value = '';

            Swal.fire({
                toast: true,
                position: 'top',
                timer: 1500,
                icon: 'success',
                showConfirmButton: false,
                title: 'Item incluído'
            });

        } catch (e) {
            console.error(e);
            Swal.fire('Erro', 'Falha ao incluir item.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const finalizarVistoria = async () => {
        if (!prazoFinalizacao) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Informe o prazo final.',
                confirmButtonColor: '#991b1b'
            });
        }

        try {
            setLoadingTexto("Fechando cabeçalho de vistoria...");
            setLoading(true);

            await api.put(`/vistoria/finalizar/${vistoriaAtual.id_vistoria}`, {
                prazo: prazoFinalizacao
            });

            Swal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: 'Vistoria finalizada.',
                confirmButtonColor: '#991b1b'
            });

            setPrazoFinalizacao('');
            setItensNovaVistoria([]);
            setVistoriaAtual(null);
            setEtapa('LISTA');

            carregarVistorias(lojaSelecionada, filtroVisao);

        } catch (e) {
            console.error(e);
            Swal.fire('Erro', 'Falha ao finalizar.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const compartilharWhatsApp = (v) => {
        const tokenValido = v.link_token || v.LINK_TOKEN;
        const baseUrl = window.location.origin;
        const link = `${baseUrl}/arbor/Loja/vistoria-execucao/${tokenValido}`;

        const msg =
            `*ARBOR - AUDITORIA INTERNA*\n` +
            `📍 *Filial:* ${v.razao}\n\n` +
            `Prezado(a) Gerente, mapeamos inconformidades na sua loja. Acesse o link abaixo para visualizar os registros fotográficos e anexar as correções efetuadas:\n\n` +
            `🔗 ${link}`;

        window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
    };

    return (
        <div className="vistoria-page-wrapper">
            <Menu modulo="ARBOR" />

            {loading && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(15, 23, 42, 0.85)',
                    zIndex: 99999, display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', padding: '20px',
                    backdropFilter: 'blur(4px)'
                }}>
                    <div className="spinner-border text-custom-red mb-3" style={{ width: '3.5rem', height: '3.5rem' }}></div>
                    <h6 className="text-white text-center fw-bold">{loadingTexto}</h6>
                </div>
            )}

            <div className="container-fluid px-3 px-md-4 mt-4 max-width-container pb-5">

                {etapa === 'LISTA' && (
                    <div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 pb-2 border-bottom gap-2">
                            <div>
                                <h5 className="fw-bold m-0 text-dark d-flex align-items-center gap-2">
                                    <FaClipboardCheck className="text-custom-red" />
                                    Gestão de Vistorias
                                </h5>
                                <span className="small text-muted">
                                    Auditoria de lojas, verificação de inconformidades e plano de ação.
                                </span>
                            </div>

                            {podeCriar && (
                                <button
                                    className="btn btn-custom-red fw-bold px-4 rounded-3 d-flex align-items-center gap-2"
                                    onClick={criarOuContinuarVistoria}
                                >
                                    <FaPlus /> Nova Vistoria
                                </button>
                            )}
                        </div>

                        <div className="card border-0 shadow-sm p-3 mb-4 bg-white rounded-3">
                            <div className="row g-2">
                                <div className={eDiretorOuRegional ? "col-12 col-md-6" : "col-12"}>
                                    <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">Filial / Loja:</label>
                                    <select
                                        className="form-select rounded-3"
                                        value={lojaSelecionada}
                                        onChange={(e) => {
                                            setLojaSelecionada(e.target.value);
                                            carregarVistorias(e.target.value, filtroVisao);
                                        }}
                                    >
                                        <option value="0">
                                            TODAS AS LOJAS (Empresa Total)
                                        </option>
                                        {lojas.map(l => (
                                            <option key={l.cod_emp} value={l.cod_emp}>
                                                Loja {l.cod_emp} - {l.razao}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {eDiretorOuRegional && (
                                    <div className="col-12 col-md-6">
                                        <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">Visão de Auditorias:</label>
                                        <select
                                            className="form-select rounded-3"
                                            value={filtroVisao}
                                            onChange={(e) => {
                                                setFiltroVisao(e.target.value);
                                                carregarVistorias(lojaSelecionada, e.target.value);
                                            }}
                                        >
                                            <option value="TODAS">
                                                TODAS AS VISTORIAS
                                            </option>
                                            <option value="MINHAS">
                                                SOMENTE MINHAS
                                            </option>
                                        </select>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row g-3">
                            {vistorias.map(v => {
                                const status = v.status || v.STATUS;
                                return (
                                    <div className="col-12 col-md-6 col-lg-4 col-xl-3" key={v.id_vistoria}>
                                        <div className="card border-0 shadow-sm rounded-3 h-100 vistoria-card-item">
                                            <div className="card-body p-3 d-flex flex-column justify-content-between">
                                                <div>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="badge bg-dark rounded-2">
                                                            #{v.id_vistoria}
                                                        </span>
                                                        <span
                                                            className={`badge ${status === 'CRIANDO'
                                                                ? 'bg-warning text-dark'
                                                                : status === 'FINALIZADA'
                                                                    ? 'bg-success text-white'
                                                                    : 'bg-danger text-white'
                                                                }`}
                                                        >
                                                            {status}
                                                        </span>
                                                    </div>

                                                    <h6 className="fw-bold text-dark mb-1 d-flex align-items-center gap-1">
                                                        <FaStore className="text-custom-red" /> Loja {v.id_loja}
                                                    </h6>
                                                    <div className="small text-muted mb-2 text-truncate" title={v.razao}>
                                                        {v.razao}
                                                    </div>

                                                    <div className="small text-danger mb-2 d-flex align-items-center gap-1 fw-semibold">
                                                        <FaCalendarAlt /> Prazo: {v.prazo || v.prazo_execucao || '-'}
                                                    </div>

                                                    <div className="small text-secondary mb-3 d-flex align-items-center gap-1">
                                                        <FaUser className="text-muted" /> {v.nome || '-'}
                                                    </div>
                                                </div>

                                                <div className="vistoria-card-actions pt-2 border-top">
                                                    {status === 'CRIANDO' ? (
                                                        <button
                                                            className="btn btn-warning btn-sm w-100 fw-bold vistoria-btn-action"
                                                            onClick={() => continuarInclusao(v)}
                                                        >
                                                            Continuar Incluindo
                                                        </button>
                                                    ) : (
                                                        <>
                                                            <button
                                                                className="btn btn-success btn-sm fw-bold vistoria-btn-action"
                                                                onClick={() => compartilharWhatsApp(v)}
                                                                title="Compartilhar no WhatsApp"
                                                            >
                                                                <FaWhatsapp /> WhatsApp
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-secondary btn-sm fw-bold vistoria-btn-action"
                                                                onClick={() => abrirAnalise(v)}
                                                            >
                                                                Analisar
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {vistorias.length === 0 && (
                                <div className="col-12 text-center py-5">
                                    <div className="bg-white p-4 rounded-4 border shadow-xs d-inline-block">
                                        <FaExclamationTriangle className="fs-1 text-warning mb-2" />
                                        <h6 className="fw-bold text-dark m-0">Nenhuma Vistoria Encontrada</h6>
                                        <p className="text-muted small m-0 mt-1">Não foram localizados registros para a loja/filtro selecionado.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {etapa === 'NOVO' && (
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                        <div className="card-body p-4">
                            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                                <div>
                                    <h5 className="fw-bold mb-1 text-dark">
                                        Nova Vistoria #{vistoriaAtual?.id_vistoria}
                                    </h5>
                                    <span className="small text-muted">Inclusão de Apontamentos e Inconformidades</span>
                                </div>
                                <span className="badge bg-warning text-dark fw-bold px-3 py-2">
                                    CRIANDO
                                </span>
                            </div>

                            <div className="mb-3">
                                <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">
                                    Descrição da Inconformidade / Apontamento
                                </label>
                                <textarea
                                    className="form-control rounded-3"
                                    rows="3"
                                    placeholder="Escreva detalhes sobre o que precisa ser corrigido ou verificado..."
                                    value={ponto.descricao}
                                    onChange={(e) =>
                                        setPonto({
                                            ...ponto,
                                            descricao: e.target.value
                                        })
                                    }
                                />
                            </div>

                            <div className="row g-2 mb-3">
                                <div className="col-12 col-md-6">
                                    <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">
                                        Tipo de Registro
                                    </label>
                                    <select
                                        className="form-select rounded-3"
                                        value={ponto.tipo}
                                        onChange={(e) =>
                                            setPonto({
                                                ...ponto,
                                                tipo: e.target.value
                                            })
                                        }
                                    >
                                        <option value="TAREFA">
                                            GERAR TAREFA (Exige Foto)
                                        </option>
                                        <option value="OBSERVACAO">
                                            APENAS OBSERVAÇÃO
                                        </option>
                                        <option value="ELOGIO">
                                            ELOGIO
                                        </option>
                                    </select>
                                </div>

                                <div className="col-12 col-md-6">
                                    <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">
                                        Registro Fotográfico
                                    </label>
                                    <label className="btn btn-outline-primary w-100 fw-bold rounded-3 d-flex align-items-center justify-content-center gap-2">
                                        <FaCamera /> Anexar / Tirar Foto
                                        <input
                                            id="foto-input"
                                            type="file"
                                            capture="environment"
                                            accept="image/*"
                                            hidden
                                            onChange={handleFotoPonto}
                                        />
                                    </label>
                                </div>
                            </div>

                            {ponto.foto && (
                                <div className="mb-3">
                                    <img
                                        src={`data:image/jpeg;base64,${ponto.foto}`}
                                        alt="Preview"
                                        onClick={() =>
                                            setFotoAmpliada(
                                                `data:image/jpeg;base64,${ponto.foto}`
                                            )
                                        }
                                        className="img-fluid rounded-3 border shadow-xs"
                                        style={{
                                            maxHeight: '220px',
                                            width: '100%',
                                            objectFit: 'cover',
                                            cursor: 'pointer'
                                        }}
                                    />
                                </div>
                            )}

                            <button
                                className="btn btn-custom-red w-100 fw-bold py-2 mb-4 rounded-3 d-flex align-items-center justify-content-center gap-2"
                                onClick={adicionarItem}
                            >
                                <FaPlus /> Incluir Item na Vistoria
                            </button>

                            <div className="vistoria-items-scroll border rounded-3 p-2 bg-light mb-3">
                                {itensNovaVistoria.length === 0 ? (
                                    <div className="text-center text-muted small py-3">Nenhum item incluído nesta vistoria até o momento.</div>
                                ) : (
                                    itensNovaVistoria.map((it, idx) => (
                                        <div key={idx} className="border rounded-3 p-2 bg-white mb-2 shadow-xs">
                                            <div className="fw-bold small text-custom-red">
                                                {it.tipo}
                                            </div>
                                            <div className="small text-dark">
                                                {it.descricao_ponto || it.descricao}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="x-small fw-bold text-muted text-uppercase d-block mb-1">
                                    Prazo Final para Execução / Resolução
                                </label>
                                <input
                                    type="date"
                                    className="form-control rounded-3"
                                    value={prazoFinalizacao}
                                    min={new Date().toISOString().split('T')[0]}
                                    onChange={(e) =>
                                        setPrazoFinalizacao(e.target.value)
                                    }
                                />
                            </div>
                        </div>

                        <div className="card-footer bg-light border-top p-3">
                            <div className="d-flex gap-2">
                                <button
                                    className="btn btn-outline-secondary w-50 fw-semibold rounded-3"
                                    onClick={() => setEtapa('LISTA')}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="btn btn-success w-50 fw-bold rounded-3"
                                    onClick={finalizarVistoria}
                                >
                                    Finalizar Tudo
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {etapa === 'ANALISE' && vistoriaEmAnalise && (
                    <div>
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2 border-bottom pb-2">
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    className="btn btn-outline-secondary btn-sm rounded-circle p-2"
                                    onClick={() => setEtapa('LISTA')}
                                    title="Voltar para a lista"
                                >
                                    <FaArrowLeft />
                                </button>
                                <h5 className="fw-bold m-0 text-dark">
                                    Análise da Vistoria #{vistoriaEmAnalise.id_vistoria}
                                </h5>
                            </div>

                            {!itensAnalise.some(item => item.loadingFoto) && (
                                <button
                                    className="btn btn-danger btn-sm rounded-3 px-3 py-2 fw-bold shadow-xs d-flex align-items-center gap-2"
                                    onClick={gerarPdfEEmail}
                                >
                                    <FaFilePdf /> Gerar Relatório e Enviar
                                </button>
                            )}
                        </div>

                        {/* CAIXA DE OBSERVAÇÕES DO SUPERVISOR */}
                        <div className="card border-0 shadow-sm p-3 mb-4 bg-white rounded-3">
                            <h6 className="fw-bold text-custom-red mb-2 d-flex align-items-center gap-2">
                                <FaClipboardCheck /> Observações e Tarefas Adicionais do Supervisor
                            </h6>
                            {eDiretorOuRegional ? (
                                <div>
                                    <textarea
                                        className="form-control mb-2 rounded-3"
                                        rows="3"
                                        placeholder="Digite aqui observações adicionais da loja, rotinas do próprio supervisor, limpeza, movimento de concorrentes, etc."
                                        value={obsSupervisorGeral}
                                        onChange={(e) => setObsSupervisorGeral(e.target.value)}
                                    />
                                    <button className="btn btn-custom-red text-white fw-bold btn-sm rounded-3 d-flex align-items-center gap-1" onClick={salvarObsSupervisor}>
                                        <FaSave /> Salvar Observações
                                    </button>
                                </div>
                            ) : (
                                <div className="alert alert-light border mb-0 small fw-semibold text-secondary">
                                    {obsSupervisorGeral || 'Nenhuma observação informada pelo supervisor.'}
                                </div>
                            )}
                        </div>

                        <div className="row g-3">
                            {itensAnalise.map(item => (
                                <div className="col-12" key={item.id_item}>
                                    <div className="card border-0 shadow-sm rounded-3 bg-white">
                                        <div className="card-body p-3">
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="badge bg-light text-dark border small">{item.tipo}</span>
                                                <span
                                                    className={`small fw-bold ${item.status_item === 'EXECUTADO'
                                                        ? 'text-success'
                                                        : item.status_item === 'REPLICA'
                                                            ? 'text-danger'
                                                            : 'text-warning'
                                                        }`}
                                                >
                                                    {item.status_item === 'EXECUTADO'
                                                        ? '● CONCLUÍDO'
                                                        : item.status_item === 'REPLICA'
                                                            ? '● REPLICA SOLICITADA'
                                                            : '○ PENDENTE'}
                                                </span>
                                            </div>
                                            <div className="fw-bold text-custom-red small mb-1">
                                                {item.tipo}
                                            </div>
                                            <div className="mb-3 text-dark">
                                                {item.descricao_ponto && item.descricao_ponto.includes('[RÉPLICA]:') ? (
                                                    <>
                                                        <div>{item.descricao_ponto.split('[RÉPLICA]:')[0].replace(/<\/?b>/gi, '')}</div>
                                                        <div className="alert alert-danger mt-2 mb-0 p-2 small fw-bold rounded-3 d-flex align-items-center gap-2">
                                                            <FaExclamationTriangle />
                                                            [RÉPLICA]: {item.descricao_ponto.split('[RÉPLICA]:')[1].replace(/<\/?b>/gi, '')}
                                                        </div>
                                                    </>
                                                ) : (
                                                    item.descricao_ponto ? item.descricao_ponto.replace(/<\/?b>/gi, '') : ''
                                                )}
                                            </div>

                                            <div className="row g-2">
                                                <div className="col-6 text-center">
                                                    <span className="small d-block text-muted mb-1 fw-bold">Antes</span>
                                                    <FotoItemPreview
                                                        foto={item.foto_antes}
                                                        loading={item.loadingFoto}
                                                        onAmpliar={setFotoAmpliada}
                                                    />
                                                </div>
                                                <div className="col-6 text-center">
                                                    <span className="small d-block text-muted mb-1 fw-bold">Depois</span>
                                                    <FotoItemPreview
                                                        foto={item.foto_depois}
                                                        loading={item.loadingFoto}
                                                        onAmpliar={setFotoAmpliada}
                                                    />
                                                </div>
                                            </div>

                                            {item.obs_gerente && (
                                                <div className="alert alert-success mt-3 mb-0 small text-break rounded-3">
                                                    <strong>{item.data_execucao}</strong> {' - '}
                                                    <strong>Usuário:</strong> {item.nome} {' - '}
                                                    <strong>Solução do Gerente:</strong> {item.obs_gerente}
                                                </div>
                                            )}

                                            {item.obs_supervisor && (
                                                <div className="alert alert-danger mt-2 mb-0 small text-break rounded-3">
                                                    <strong>Motivo da Réplica (Supervisor):</strong> {item.obs_supervisor}
                                                </div>
                                            )}

                                            {eDiretorOuRegional && item.status_item === 'EXECUTADO' && (
                                                <button
                                                    className="btn btn-outline-danger btn-sm w-100 fw-bold mt-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                                                    onClick={() => solicitarReplicaSupervisor(item)}
                                                >
                                                    <FaUndo /> Exigir Réplica / Refação de Foto
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>

            {/* MODAL DE EDICAO GRAFICA */}
            {previewEdicao && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: '#ffffff',
                        zIndex: 999999,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <div className="p-3 bg-dark text-white d-flex justify-content-between align-items-center">
                        <span className="fw-bold d-flex align-items-center gap-2">
                            <FaPencilAlt /> Marcar Inconformidade na Imagem
                        </span>
                        <button
                            className="btn btn-success btn-sm fw-bold px-3 rounded-3"
                            onClick={salvarEdicaoFoto}
                        >
                            Confirmar
                        </button>
                    </div>

                    <div style={{ flex: 1, position: 'relative', background: '#000' }}>
                        <ReactSketchCanvas
                            ref={canvasRef}
                            strokeWidth={6}
                            strokeColor="red"
                            backgroundImage={previewEdicao}
                            preserveBackgroundImageAspectRatio="xMidYMid meet"
                            style={{ width: '100%', height: '100%' }}
                        />
                    </div>

                    <div className="p-3 d-flex gap-2 bg-light border-top">
                        <button
                            className="btn btn-outline-secondary w-100 rounded-3 fw-semibold"
                            onClick={() => setPreviewEdicao(null)}
                        >
                            Voltar sem Marcar
                        </button>

                        <button
                            className="btn btn-danger w-100 rounded-3 fw-bold"
                            onClick={() => canvasRef.current.clearCanvas()}
                        >
                            Limpar
                        </button>
                    </div>
                </div>
            )}

            {/* MODAL FOTO AMPLIADA */}
            {fotoAmpliada && (
                <div
                    onClick={() => setFotoAmpliada(null)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(15, 23, 42, 0.9)',
                        backdropFilter: 'blur(4px)',
                        zIndex: 99999999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '16px'
                    }}
                >
                    <img
                        src={fotoAmpliada}
                        alt="Zoom"
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px'
                        }}
                    />
                </div>
            )}

            <Footer />
        </div>
    );
};

export default VistoriaGestao;